<template>
	<md-dialog
		:append-to-body="true"
		@close="$emit('close', false)"
		:md-active="show"
		style="font-family: 'Montserrat', sans-serif; z-index: 2000"
	>
		<div style="width: 500px">
			<div class="dialog-header">
				<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{ $t("wizard") }}</span>
				<div style="margin-left: auto; margin-right: 0">
					<md-button @click="$emit('close', false)" class="md-icon-button" style="margin-right: -5px">
						<md-icon style="color: white">close</md-icon>
					</md-button>
				</div>
			</div>
			<div class="dialog-body">
				<div class="container">
					<wizard-render
						v-if="load"
						@add="value => $emit('add', value)"
						:key="processed_id"
						@end="value => $emit('end', value)"
						@change="value => next(value)"
						@replace="value => replace(value)"
						:id="processed_id"
					></wizard-render>
				</div>
			</div>
			<div class="dialog-footer">
				<div style="margin-left: auto; margin-right: 0">
					<!-- <md-button class="cancel" @click="$emit('close', false)">
						{{ $t("cancel") }}
					</md-button> -->
					<md-button class="cancel" @click="goBack">
						{{ $t("back") }}
					</md-button>
				</div>
			</div>
		</div>
	</md-dialog>
</template>
<script>
import WizardRender from "@/modules/wizard/modals/wizard-render"
import { uuid } from "@/modules/builder/utils/utils"
import LoadingGeneric from "@/modules/_common/loading-generic"
export default {
	name: "wizard-modal",
	components: { LoadingGeneric, WizardRender },
	props: ["wizard_id", "show"],
	data() {
		return {
			history: [],
			emitted_id: undefined,
			load: true,
			forceLoad: uuid()
		}
	},
	computed: {
		processed_id() {
			return this.history.at(-1)
		}
	},
	created() {
		this.history.push(this.wizard_id)
	},
	beforeDestroy() {
		this.history = []
		this.emitted_id = undefined
	},
	methods: {
		uuid,
		goBack() {
			this.load = false
			if (this.history.length <= 1) {
				this.$emit("close", false)
			} else {
				this.history.pop()
			}

			this.forceLoad = uuid()
			this.load = true
		},
		replace(val) {
			this.load = false

			if (this.history.length <= 1) {
				this.$emit("close", false)
			} else {
				this.history.splice(-1, 1, val)
			}

			this.forceLoad = uuid()
			this.load = true
		},
		next(val) {
			this.load = false
			this.history.push(val)
			this.forceLoad = uuid()
			this.load = true
		}
	}
}
</script>
<style scoped>
.dialog-footer {
	position: relative;
}
</style>
